import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import ListItemAvatar from '@mui/material/ListItemAvatar';

const StyledListItemAvatar = styled(ListItemAvatar)` 
  ${ComponentStyles}
`;

StyledListItemAvatar.propTypes = {
  theme: PropTypes.object
};

export default StyledListItemAvatar;
